import styled from 'styled-components';
import {Card, CardActionArea, CardContent} from "@material-ui/core";
import CodeIcon from '@material-ui/icons/Code';
import React from "react";
import {Job, JobCategory, JobCategoryTypes, StyledBaseProps} from "@betrue/shared/interfaces";
import BarChartIcon from '@material-ui/icons/BarChart';
import ChatBubbleOutlineOutlinedIcon from '@material-ui/icons/ChatBubbleOutlineOutlined';
import VideogameAssetOutlinedIcon from '@material-ui/icons/VideogameAssetOutlined';
import EqualizerOutlinedIcon from '@material-ui/icons/EqualizerOutlined';
import CameraEnhanceOutlinedIcon from '@material-ui/icons/CameraEnhanceOutlined';
import ShopOutlinedIcon from '@material-ui/icons/ShopOutlined';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import ComputerOutlinedIcon from '@material-ui/icons/ComputerOutlined';

export interface JobCategoryViewProps extends StyledBaseProps {
  jobCategory: JobCategory
  onCategorySelected: (jc: JobCategory) => void

}

const ICONS = {
  [JobCategoryTypes.TECH]: CodeIcon,
  [JobCategoryTypes.DATA]: EqualizerOutlinedIcon,
  [JobCategoryTypes.COMMUNICATION]: ChatBubbleOutlineOutlinedIcon,
  [JobCategoryTypes.PICTURE_SOUND]: CameraEnhanceOutlinedIcon,
  [JobCategoryTypes.MARKETING]: ShopOutlinedIcon,
  [JobCategoryTypes.VIDEO_GAMES]: VideogameAssetOutlinedIcon,
  [JobCategoryTypes.BUSINESS_CONSULTING]: BarChartIcon,
  [JobCategoryTypes.PROJECT_MANAGER_AGILE]: SupervisorAccountIcon,
  [JobCategoryTypes.WEB_GRAPHIC_DESIGN]: ComputerOutlinedIcon,

}

export const JobCategoryItemView = styled((props: JobCategoryViewProps) => {
  const ICON = ICONS[props.jobCategory.category]

  return (
    <Card className={props.className} onClick={() => props.onCategorySelected(props.jobCategory)}>
      <CardActionArea>
        <CardContent>
          <h2>{props.jobCategory.label} <ICON/></h2>
          <p>{props.jobCategory.jobs.slice(0, 3).reduce(
            (acc, j) => {
              return acc ? acc + ', ' + j.label : j.label
            }, '').concat('...')}</p>
        </CardContent>
      </CardActionArea>
    </Card>)
})`
  & h2 {
    color: ${props => props.theme.colors.secondary}
  }
  & p {
    color: ${props => props.theme.colors.secondary}
  }
`

export interface JobItemProps extends StyledBaseProps {
  job: Job,
  onJobSelect: (Job) => void
}

export const JobItemView = styled((props: JobItemProps) =>
  (
    <span className={props.className}>
      <Card onClick={() => props.onJobSelect(props.job)}>
        <CardActionArea>
           <CardContent>
             <h3>{props.job.label}</h3>
           </CardContent>
        </CardActionArea>
      </Card>
    </span>

  ))`
  margin: 10px;
`
